module.exports = __webpack_public_path__ + "static/media/mum_cutting_grass.eb918782.png";